import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/entities/documents';

const fetchGenericDocuments = createAction('fetchGenericDocuments');
const fetchCustomDocuments = createAction('fetchCustomDocuments');

function fetchGenericDocumentsSuccess(state, action) {
  state.successFetching = true;
  state.errorFetching = false;
  state.document = { ...action.payload };
}

// ✅ UNA SOLA FUNCIÓN PARA AMBOS ERRORES
function fetchDocumentsError(state) {
  state.successFetching = false;
  state.errorFetching = true;
  state.document = null;
}

function fetchCustomDocumentsSuccess(state, action) {
  state.successFetching = true;
  state.errorFetching = false;
  state.pdf = action.payload.documento;
}

const documentsReducer = createSlice({
  name: 'documents',
  initialState,
  reducers: {
    fetchGenericDocumentsSuccess,
    fetchGenericDocumentsError: fetchDocumentsError,    
    fetchCustomDocumentsSuccess,
    fetchCustomDocumentsError: fetchDocumentsError,
  },
});

export const documentsActions = {
  ...documentsReducer.actions,
  fetchGenericDocuments,
  fetchCustomDocuments,
};

export default documentsReducer.reducer;